import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedWork from './components/FeaturedWork';
import About from './components/About';
import Services from './components/Services';
import StatsSection from './components/StatsSection';
import MarqueeSection from './components/MarqueeSection';
import HorizontalScroll from './components/HorizontalScroll';
import TestimonialsSection from './components/TestimonialsSection';
import Blog from './components/Blog';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import SmoothScroll from './components/SmoothScroll';
import PageLoader from './components/PageLoader';
import ScrollProgress from './components/ScrollProgress';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // Refresh ScrollTrigger on mount and resize
    ScrollTrigger.refresh();
    
    const handleResize = () => {
      ScrollTrigger.refresh();
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <PageLoader />
      <ScrollProgress />
      <SmoothScroll>
        <div className="App">
          <CustomCursor />
          <Header />
          <Hero />
          <FeaturedWork />
          <About />
          <StatsSection />
          <MarqueeSection />
          <Services />
          <HorizontalScroll />
          <TestimonialsSection />
          <Blog />
          <Footer />
        </div>
      </SmoothScroll>
    </>
  );
}

export default App;